/**
 * Created by Mike Naughton on 10/18/17.
 *
 * Let's hope that this stays a simple utility module
 */

import _ from "underscore";

export default {
  /**
   * Gets an object that can be used as attributes to instantiate a Field
   * @param {String} name The name and ID of the field to create
   * @param {String} label A user-facing label for the field
   * @param {String} editorType The type of editor the field should present
   * @param {Object} [options] A hash of additional options.
   */
  fieldPrototype: function (name, label, editorType, options) {
    return _.defaults(
      {
        id: name,
        name: name,
        label: label,
        editor: editorType,
      },
      options
    );
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/utils/FieldUtils.js
// module id = 76
// module chunks = 1